<style scoped>


</style>

<template>

  <v-flex shrink>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="600px" :lazy="true" :fullscreen="$vuetify.breakpoint.smAndDown">
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on" @click="clearForms">{{content.forgot_pass}}</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline text-xs-center mx-auto mt-2">{{content.title}}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-alert :value="error === 1" color="error" outline class="text-xs-center">
                {{content.banned}}.<br>
                {{content.banned2}} {{banned}} {{content.minutes}}.
              </v-alert>
              <v-alert :value="error === 3" color="error" icon="warning" outline class="text-xs-center">
                {{content.invalid}}.<br>
              </v-alert>
              <v-alert :value="error === 4" color="error" icon="warning" outline class="text-xs-center">
                {{content.incorrect}}.<br>
                {{content.tries}}: {{tries}}
              </v-alert>
              <v-alert :value="error === 5" color="warning" icon="warning" outline class="text-xs-center">
                {{content.failed}}.
              </v-alert>
              <v-alert :value="error === 6" color="error" icon="warning" outline class="text-xs-center">
                {{content.reseted}}.<br>
                {{content.reseted2}}.
              </v-alert>

              <v-layout v-if="phase === 1" row wrap justify-center>
                <v-flex xs12>
                  <p>
                    {{content.need1}}<br>
                    {{content.need2}}
                  </p>
                </v-flex>
                <v-flex xs12>
                  <v-form @submit.prevent="sendEmail" ref="email">
                    <v-layout row wrap justify-center>
                      <v-flex xs12>
                        <v-text-field color="green" v-model="form.email" :label="content.email" type="email" :rules="rules.email" autocomplete="off"></v-text-field>
                      </v-flex>
                      <v-flex xs6 d-flex column justify-center>
                        <v-layout column wrap justify-center>
                          <v-btn :disabled="countdown" color="primary" type="submit" :loading="loadings.email">{{content.sendCode}}</v-btn>
                          <span v-if="countdown" class="text-xs-center">{{content.resend_possible +' '+ this.countdownTime +' '+ content.seconds}}</span>
                        </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>

            <v-layout v-show="phase === 2" row wrap justify-center>
              <v-flex xs12>
                <p>
                  {{content.sent}} - <strong>{{form.email}}</strong>.<br>
                  {{content.copy}}
                </p>
              </v-flex>
              <v-flex xs12>
                <v-form @submit.prevent="submitCode" ref="resetcode">
                  <v-layout row wrap justify-center>
                    <v-flex xs12>
                      <v-text-field type="text" color="green" v-model="form.code" :label="content.code" :rules="[rules.code]" autocomplete="off"></v-text-field>
                    </v-flex>
                    <v-flex xs6 d-flex justify-center>
                      <v-btn color="primary" type="submit" :loading="loadings.code">{{content.reset}}</v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
                <p class="text-xs-center mt-5 mb-0">{{content.wrong_email}}</p>
              </v-flex>
            </v-layout>

            <v-layout v-if="phase === 3 && !success" row wrap justify-center>
              <v-flex xs12>
                <p>
                  {{content.new_passwords}}
                </p>
              </v-flex>
              <v-flex xs12>
                <v-form @submit.prevent="submitPassword" ref="password">
                  <v-layout row wrap justify-center>
                    <v-flex xs12 v-show="false">
                      <v-text-field type="email" name="email" v-model="form.email" autocomplete="username"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row nowrap>
                        <v-flex v-if="form.password" shrink>
                          <v-btn flat icon color="primary" @click="passwords.reveal.new = !passwords.reveal.new">
                            <v-icon>{{passwords.reveal.new ? 'visibility_off' : 'visibility'}}</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex grow>
                          <v-text-field autocomplete="new-password" :type="passwords.reveal.new ? 'text' : 'password'" v-model="form.password" :label="content.new_password" :rules="rules.new_password" validate-on-blur :reverse="locale == 'he' ? true : false"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row nowrap>
                        <v-flex v-if="form.password_confirmation" shrink>
                          <v-btn flat icon color="primary" @click="passwords.reveal.confirm = !passwords.reveal.confirm">
                            <v-icon>{{passwords.reveal.confirm ? 'visibility_off' : 'visibility'}}</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex grow>
                          <v-text-field autocomplete="new-password" :type="passwords.reveal.confirm ? 'text' : 'password'" v-model="form.password_confirmation" :label="content.confirm+' '+content.password" :rules="rules.confirm_password" validate-on-blur :reverse="locale == 'he' ? true : false"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12>
                      <passwordStr :password="form.password" v-on:pwdStr="updatePwdStr" class="mx-4" />
                    </v-flex>

                    <v-flex xs6 d-flex justify-center>
                      <v-btn color="primary" type="submit" :loading="loadings.password">{{content.submitPassword}}</v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
            <v-flex xs12 v-if="success" row wrap>
              <v-alert :value="true" color="success" icon="check_circle" outline class="text-xs-center ma-3">
                {{content.success}}!
              </v-alert>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="grey darken-1" flat @click="dialog = false">{{content.close}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="phase === 2" color="black" flat @click="goBack">{{content.back}}</v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-flex>

</template>

<script>

import passwordStr from '../tools/passwordStr';
export default {
    name: 'Forgotpwd',
    components: { passwordStr },
    data() {
        return {
            loginErr: false,
            locale: null,
            dialog: false,
            phase: 1,
            form: {
              email: null,
              code: null,
              password: null,
              password_confirmation: null,
            },
            used_email: null,
            token: null,
            rules: {
                email: [
                  v => !!v || this.content.validation.email[0],
                  v => /.+@.+\..+/.test(v) || this.content.validation.email[1]
                ],
                code: v => !!v || this.content.validation.code,
                new_password: [
                  v => !!v || this.content.validation.passwords.new[0],
                  v => v != this.form.current_password || this.content.validation.passwords.new[3],
                  v => this.passwords.strength > 25 || this.content.validation.passwords.new[1],
                  v => v && v.length < 19 || this.content.validation.passwords.new[2],
                ],
                confirm_password: [
                  v => !!v || this.content.validation.passwords.confirm[0],
                  v => v == this.form.password || this.content.validation.passwords.confirm[1],
                ],
            },
            loadings: {
              email: false,
              code: false,
              password: false,
            },
            passwords: {
              reveal: {
                new: false,
                confirm: false,
              },
              strength: 0,
            },
            time: null,
            countdown: false,
            countdownTime: 0,
            error: 0,
            banned: 0,
            tries: 0,
            success: false,
            content: {}
        };
    },
    created() {
        this.locale = Lang.get();
        this.setLang();
    },
    watch: {
        'form.code': {
            handler: function (after, before) {
              if (this.form.code != null) {
                this.form.code = after.replace(' ', '').replace('	', '');
              }
            },
            deep: true
        },
        'form.email': {
            handler: function (after, before) {
              if (this.used_email) {
                if (this.form.email === this.used_email && this.countdownTime > 0) {
                  this.countdown = true;
                } else {
                  this.countdown = false;
                }
              } else {
                this.countdown = false;
              }
            },
            deep: true
        }
    },
    methods: {
        clearForms() {
          this.form = {
            email: null,
            code: null,
            password: null,
            password_confirmation: null,
          };
          setTimeout(() => {
            this.$refs.email.resetValidation();
            this.$refs.email.$el[0].focus();
          }, 100);
          this.phase = 1;
        },
        goBack(){
          this.phase = 1;
          this.error = 0;
        },
        sendEmail() {
          this.error = 0;
          if (this.$refs.email.validate()) {
            this.loadings.email = true;
            axios.get(
              'api/reset-password/send-email?email=' + this.form.email.trim()
            ).then(res => {
              this.loadings.email = false;
              if (res.data.failed === 'banned') {
                this.error = 1;
                this.banned = Math.round(res.data.time /60);
                this.countdown = true;
                console.log(res.data.time);
                this.countdownTime = res.data.time;
                clearInterval(this.timer);
                this.timer = setInterval(function() {
                  this.countdownTime = this.countdownTime - 1;
                  if(this.countdownTime == 0){
                    this.countdown = false;
                    clearInterval(this.timer);
                  }
                }.bind(this), 1000);
              } else if (res.data.failed === 'soon') {
                this.error = 2;
                this.used_email = this.form.email;
                this.countdown = true;
                this.countdownTime = 60 - res.data.time;
                clearInterval(this.timer);
                this.timer = setInterval(function() {
                  this.countdownTime = this.countdownTime - 1;
                  if(this.countdownTime == 0){
                    this.countdown = false;
                    clearInterval(this.timer);
                  }
                }.bind(this), 1000);
              } else {
                this.error = 0;
                this.phase = 2;
                this.$refs.resetcode.reset();
                this.$refs.resetcode.resetValidation();
                this.countdown = true;
                this.countdownTime = 60;
                clearInterval(this.timer);
                this.timer = setInterval(function() {
                  this.countdownTime = this.countdownTime - 1;
                  if(this.countdownTime == 0){
                    this.countdown = false;
                    clearInterval(this.timer);
                  }
                }.bind(this), 1000);
                this.used_email = this.form.email;
              }
            }).catch(err => {
              this.error = 5;
              this.loadings.email = false;
            });
          }
        },
        submitCode() {
          this.error = 0;
          if (this.$refs.resetcode.validate()) {
            this.loadings.code = true;
            axios.post(
              'api/reset-password/check-code',
              {
                code: this.form.code,
                email: this.form.email,
              }
            ).then(res => {
              this.loadings.code = false;
              if (res.data.success === 'correct') {
                this.loadings.code = false;
                this.phase = 3;
                this.token = res.data.token;
              } else if (res.data.failed === 'deleted') {
                this.error = 3;
                this.form.email = null;
                this.phase = 1;
              } else if (res.data.failed === 'banned') {
                this.error = 1;
                this.banned = Math.round(res.data.time);
                this.countdown = true;
                this.countdownTime = (60*60);
                clearInterval(this.timer);
                this.timer = setInterval(function() {
                  this.countdownTime = this.countdownTime - 1;
                  if(this.countdownTime == 0){
                    this.countdown = false;
                    clearInterval(this.timer);
                  }
                }.bind(this), 1000);
                this.phase = 1;
              } else if (res.data.failed === 'incorrect') {
                this.tries = res.data.tries;
                this.error = 4;
              }
            }).catch(err => {
              this.error = 5;
              this.loadings.code = false;
            })
          }
        },
        updatePwdStr(str) {
          this.passwords.strength = str;
        },
        submitPassword() {
          if (this.$refs.password.validate()) {
            this.error = 0;
            axios.post(
              'api/reset-password/change-password',
              {
                token: this.token,
                password: this.form.password,
                password_confirmation: this.form.password_confirmation
              }
            ).then(res => {
              if (res.data.success === 'success') {
                this.success = true;
                this.error = 0;
                this.form = {
                  email: null,
                  code: null,
                  password: null,
                  password_confirmation: null,
                };
                setTimeout(() => {
                  this.dialog = false,
                  this.success = false;
                  this.phase = 1;
                }, 2500);
              } else if (res.data.failed === 'reseted') {
                this.error = 6;
                this.form = {
                  email: null,
                  code: null,
                  password: null,
                  password_confirmation: null,
                };
                this.phase = 1;
              }
            }).catch(err => {
              this.error = 5;
              this.loadings.code = false;
            });
          }
        },
        setLang() {
            if (this.locale == "en") {
                this.content = {
                    title: 'Reset Your Password',
                    forgot_pass: 'Forgot Password',
                    password: 'Password',
                    close: 'close',
                    back: 'go back',
                    validation: {
                      email: [
                        'You must fill the Email Address',
                        'Email Address is invalid'
                      ],
                      code: 'You must fill the Reset Code',
                      passwords: {
                        new: [
                          'You must fill New Password',
                          'New Password is too weak',
                          'New Password is too long',
                          'You can\'t use the same password',
                        ],
                        confirm: [
                          'You must fill Password Confirmation',
                          'The passwords does not match',
                        ],
                      },
                    },
                    oops: 'Looks like something went wrong! please try again!',
                    need1: 'To reset the password, we need to send you an email with a "Reset Code".',
                    need2: 'Please fill the Email Address that associated with your account',
                    email: 'Email Address',
                    sendCode: 'Send Reset Code',
                    sent: 'The email has been sent with the Reset Code',
                    copy: 'Copy the Code to the input below',
                    code: 'Reset Code',
                    reset: 'Reset',
                    confirm: 'Confirm',
                    wrong_email: 'If the email didn\'t arrive, please make sure you filled it correctly',
                    new_passwords: 'Choose A New Password',
                    new_password: 'New Password',
                    current_password: 'Current Password',
                    resend: 'Send Again',
                    resend_possible: 'will be possible in',
                    seconds: 'seconds',
                    submitPassword: 'Change Password',
                    banned: 'You are currently blocked from resetting the password due to multiple failed attempts',
                    banned2: 'Please try again in about ',
                    minutes: 'minutes',
                    invalid: 'There is no valid code in the system, please fill in the email address to send a new code',
                    incorrect: 'The code you entered is invalid',
                    tries: 'Attempts you have left before blocking',
                    failed: 'Something went wrong, please try again',
                    reseted: 'You are not allowed to reset a password',
                    reseted2: 'The Reset Code has been deleted, please restart the process',
                    success: 'Password Changed Successfully'
                };
            } else if (this.locale == "he") {
                this.content = {
                    title: 'איפוס סיסמא',
                    forgot_pass: 'שכחתי סיסמא',
                    password: 'סיסמא',
                    close: 'סגירה',
                    back: 'חזור שלב',
                    validation: {
                      email: [
                        'חובה להזין כתובת אימייל',
                        'כתובת האימייל אינה תקינה'
                      ],
                      code: 'חובה להזין את קוד האיפוס',
                      passwords: {
                        new: [
                          'נדרש למלא סיסמא חדשה',
                          'הסיסמא החדשה חלשה מידי',
                          'הסיסמא החדשה ארוכה מידי',
                          'אי אפשר להשתמש באותה הסיסמא',
                        ],
                        confirm: [
                          'נדרש למלא אישור סיסמא',
                          'הסיסמאות אינן תואמות',
                        ],
                      },
                    },
                    oops: 'נראה שמשהו השתבש! אנא נסה שנית!',
                    need1: "על מנת לאפס את הסיסמא, אנו נדרשים לשלוח אליך אימייל עם 'קוד איפוס'.",
                    need2: 'אנא מלא את כתובת האימייל המשויכת לחשבונך.',
                    email: 'כתובת אימייל',
                    sendCode: 'שלח קוד איפוס',
                    sent: 'האימייל נשלח עם הקוד לכתובת האימייל',
                    copy: 'תעתיק את הקוד המצורף לתיבה מתחת.',
                    code: 'קוד איפוס',
                    reset: 'איפוס',
                    confirm: 'אישור',
                    wrong_email: 'אם האימייל לא הגיע, אנא תוודא שהזנת אותו כמו שצריך.',
                    new_passwords: 'בחירת סיסמא חדשה',
                    new_password: 'סיסמא חדשה',
                    current_password: 'סיסמא נוכחית',
                    resend: 'שלח שוב',
                    resend_possible: 'יתאפשר בעוד',
                    seconds: 'שניות',
                    submitPassword: 'שינוי סיסמא',
                    banned: 'הינך חסום כרגע מלאפס את הסיסמא עקב ניסיונות כושלים מרובים',
                    banned2: 'אנא נסה שוב בעוד כ-',
                    minutes: 'דקות',
                    invalid: 'אין קוד תקין במערכת, אנא מלא את כתובת האימייל כדי שנשלח קוד חדש',
                    incorrect: 'הקוד שהזנת אינו תקין',
                    tries: 'ניסיונות שנשארו לך לפני שתיחסם',
                    failed: 'משהו השתבש, אנא נסה שנית',
                    reseted: 'אינך מורשה לאפס סיסמא',
                    reseted2: 'הקוד איפוס נמחק, אנא התחל את התהליך מחדש',
                    success: 'הסיסמא שונתה בהצלחה',
                };
            }
        }
    }
};

</script>
